export const GET_MEDIAS_REQUEST = "GET_MEDIAS_REQUEST";
export const GET_MEDIAS_SUCCESS = "GET_MEDIAS_SUCCESS";
